<template>
  <div class="outro" :class="{ ['is-ie']: $browserDetect.isIE }">
    <div class="header">
      <p class="title">
        <slot name="title"></slot>
      </p>
      <p class="sub-title">
        <slot name="sub-title"></slot>
      </p>
    </div>
    <div class="content" v-if="!hideContent">
      <div class="score-wrapper">
        <p class="score-title">
          <slot name="score-title"></slot>
        </p>
        <div class="score-details" v-if="status === 'success'">
          <p class="detail-title">
            <slot name="success-detail-title"></slot>
          </p>
          <p class="detail-content">
            <slot name="success-detail-content"></slot>
          </p>
        </div>
        <div class="score-details" v-if="status === 'normal'">
          <p class="detail-title">
            <slot name="normal-detail-title"></slot>
          </p>
          <p class="detail-content">
            <slot name="normal-detail-content"></slot>
          </p>
        </div>
        <div class="score-details" v-if="status === 'fail'">
          <p class="detail-title">
            <slot name="fail-detail-title"></slot>
          </p>
          <p class="detail-content">
            <slot name="fail-detail-content"></slot>
          </p>
        </div>
      </div>
      <div class="memo-wrapper" v-if="memo.link">
        <p class="title">Fiche mémo à télécharger</p>
        <a :href="'/' + memo.link" target="_blank" class="download-button">{{ memo.label }}</a>
      </div>
    </div>
    <div class="memo-wrapper" v-if="hideContent && memo.link">
      <p class="title">Fiche mémo à télécharger</p>
      <a :href="'/' + memo.link" target="_blank" class="download-button">{{ memo.label }}</a>
    </div>
    <div v-if="showExitButton" class="exit-wrapper">
      <p class="title">Vous avez complété ce module.</p>
      <button @click="$store.dispatch('exit')" class="button">Enregistrer et quitter</button>
    </div>
    <div v-else>
      <button @click="$emit('next')" class="button">{{ buttonLabel }}</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OutroTemplate',
  props: {
    buttonLabel: {
      type: String,
      required: false,
      default () {
        return 'Continuer'
      }
    },
    status: {
      type: String,
      required: true
    },
    memo: {
      type: Object,
      required: false,
      default () {
        return {}
      }
    },
    showExitButton: {
      type: Boolean,
      required: false,
      default () {
        return false
      }
    },
    hideContent: {
      type: Boolean,
      required: false,
      default () {
        return false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.outro {
  width: 100%;
  height: 100%;
  position: relative;
  flex-grow: 1;
  overflow: hidden;
  padding-bottom: 280px;
  display: flex;
  align-items: center;
  flex-direction: column;
  &:after {
    content: 'GTA';
    position: absolute;
    color: rgba(255, 255, 255, 0.5);
    font-size: 341px;
    font-weight: 700;
    bottom: 0;
    right: 0;
    line-height: 235px;
  }

  .header {
    width: 1024px;
    margin: 0 auto;
    padding-top: 60px;
    text-align: left;
    .title {
      font-family: $secondary-font;
      font-weight: 700;
      font-size: 0.95rem;
      color: $secondary-text-color;
    }
    .sub-title {
      margin-top: 10px;
      font-size: 1.9rem;
    }
  }
  .content {
    max-width: 1024px;
    margin-top: 30px;
    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.16);
    border-radius: $radius-sm;
    background-color: #fff;
    display: flex;
    text-align: left;
    padding: 5px 0;
    .score-wrapper {
      padding: 25px;
      display: flex;
      flex-direction: column;
      .score-title {
        font-weight: 700;
        font-size: 1.25rem;
      }
      .score-details {
        display: flex;
        flex-grow: 1;
        justify-content: center;
        flex-direction: column;
        background-color: $background-color;
        border-radius: $radius-md;
        padding: 25px 20px;
        margin-top: 20px;
        min-width: 564px;
        .detail-title {
          font-weight: 700;
          font-size: 1.1rem;
        }
        .detail-content {
          margin-top: 5px;
          font-family: $secondary-font;
          font-size: 0.95rem;
        }
      }
    }
  }
  .memo-wrapper {
    min-height: 172px;
    min-width: 380px;
    margin: 25px 20px 25px 10px;
    background-color: $secondary-color;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    border-radius: $radius-sm;
    .title {
      margin-bottom: 30px;
      font-weight: 700;
      font-size: 1.25rem;
    }
  }
  .exit-wrapper {
    margin-top: 20px;
    width: 1024px;
    max-width: 100%;
    padding: 20px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    color: #fff;
    background-color: $primary-color;
    border-radius: $radius;
    .title {
      font-size: 1.8rem;
      font-weight: 700;
    }
    .button {
      margin-top: 20px;
    }
  }
  .button {
    margin-top: 40px;
    width: 320px;
  }
  &.is-ie {
    .content {
      .score-wrapper {
        max-width: 610px;
      }
    }
  }
}
</style>
